function DropDown(props) {
  return (
    <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 0.5L8 7.5L0.5 0.499999" stroke="#6D7887" stroke-linecap="round" />
    </svg>

  )
}

export default DropDown
